import axios from "axios";

export default {
  getCleanLogList: (orderid) => {
    return axios.get("/a1/order/orderclean", { params: { id: orderid } });
  },
  findCleanOrderGoods(params) {
    return axios.post("/a1/order/orderclean/find", params);
  },
  // 修改售后商品
  EditAfterSaleGoods(params){
    return axios.post("/a1/order/afterSale/editGoods",params);
  }
};
